import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MapComponent} from './map.component';
import {LayoutModule} from '../../components/layout/layout.module';
import {MaterialModule} from '../../material.module';
import {ActionBarModule} from '../../components/action-bar/action-bar.module';
import {MapDiagramComponent} from './map-diagram/map-diagram.component';
import {DndModule} from 'ngx-drag-drop';
import {NetworkDiagramModule} from '../../utils/network-diagram/network-diagram.module';
import {EcoFabSpeedDialModule} from '@ecodev/fab-speed-dial';
import {ClusterDialogComponent} from './cluster-dialog/cluster-dialog.component';
import {FormsModule} from '@angular/forms';
import {DialogModule} from '../../components/dialog/dialog.module';
import {ConnectionSummaryComponent} from './map-summary/connection-summary/connection-summary.component';
import {NodeSummaryComponent} from './map-summary/node-summary/node-summary.component';
import {MapSummaryGraphsComponent} from './map-summary/nothing-selected-summary/map-summary-graphs/map-summary-graphs.component';
import {MapSummaryTestRouteComponent} from './map-summary/nothing-selected-summary/map-summary-test-route/map-summary-test-route.component';
import {MapSummaryTopRoutesComponent} from './map-summary/nothing-selected-summary/map-summary-top-routes/map-summary-top-routes.component';
import {PeerConnectionAggregationSummaryComponent} from './map-summary/peer-connection-aggregation-summary/peer-connection-aggregation-summary.component';
import {PeerConnectionSummaryComponent} from './map-summary/peer-connection-summary/peer-connection-summary.component';
import {VoipPeerAggregationSummaryComponent} from './map-summary/voip-peer-aggregation-summary/voip-peer-aggregation-summary.component';
import {VoipPeerSummaryComponent} from './map-summary/voip-peer-summary/voip-peer-summary.component';
import {HighchartModule} from '../../utils/highchart/highchart.module';
import {MapSummaryComponent} from './map-summary/map-summary.component';
import {InfoWrappersModule} from '../../utils/info-wrappers/info-wrappers.module';
import {NothingSelectedSummaryComponent} from './map-summary/nothing-selected-summary/nothing-selected-summary.component';
import {InfraModule} from 'ac-infra';
import {DividerModule} from '../../components/separator/divider.module';
import {AgGridModule} from 'ag-grid-angular';
import { TestRouteDialogComponent } from './test-route-dialog/test-route-dialog.component';
import { MapSearchComponent } from './map-search/map-search.component';
import {SearchModule} from '../../components/search/search.module';
import { TestRouteDetailsDialogComponent } from './test-route-details-dialog/test-route-details-dialog.component';
import {ManipulationGridModule} from '../../components/manipulation-grid/manipulation-grid.module';
import {ContextMenuModule} from '@perfectmemory/ngx-contextmenu';

@NgModule({
  declarations: [
    MapComponent,
    MapDiagramComponent,
    ClusterDialogComponent,
    ConnectionSummaryComponent,
    MapSummaryComponent,
    NodeSummaryComponent,
    MapSummaryGraphsComponent,
    MapSummaryTestRouteComponent,
    MapSummaryTopRoutesComponent,
    NothingSelectedSummaryComponent,
    PeerConnectionAggregationSummaryComponent,
    PeerConnectionSummaryComponent,
    VoipPeerAggregationSummaryComponent,
    VoipPeerSummaryComponent,
    TestRouteDialogComponent,
    MapSearchComponent,
    TestRouteDetailsDialogComponent
  ],
  imports: [
    CommonModule,
    LayoutModule,
    MaterialModule,
    ActionBarModule,
    ContextMenuModule.forRoot(),
    DndModule,
    NetworkDiagramModule,
    EcoFabSpeedDialModule,
    FormsModule,
    DialogModule,
    HighchartModule,
    InfoWrappersModule,
    InfraModule,
    DividerModule,
    AgGridModule,
    SearchModule,
    ManipulationGridModule
  ]
})
export class MapModule {
}
